import axios from '@/utils/api'
import FileSaver from 'file-saver'

const actions = {
  async downloadArquivoEstatico ({ commit }, nome) {
    const response = await axios({
      method: 'get',
      url: `publico/arquivo/bytes/${nome}`,
      responseType: 'blob' // Importante em caso de download de files
    })
    FileSaver.saveAs(response, nome)
  },

  async downloadSicarfOff ({ commit }, codigo) {
    await axios({
      method: 'get',
      url: `publico/arquivo/sicarfOff/${codigo}`,
      responseType: 'blob' // Importante em caso de download de files
    })
  },

  async downloadManual ({ commit }, codigo) {
    await axios({
      method: 'get',
      url: `publico/arquivo/manual/${codigo}`,
      responseType: 'blob' // Importante em caso de download de files
    })
  },

  async visualizarPdf ({commit}, nome) {
    const response = await axios({
      method: 'get',
      url: `publico/arquivo/bytes/${nome}`,
      responseType: 'arraybuffer'
    })
    return response
  },

  async downloadModeloDeclaracao ({ commit }, codigo) {
    await axios({
      method: 'get',
      url: `publico/arquivo/modeloDeclaracao/${codigo}`,
      responseType: 'blob' // Importante em caso de download de files
    })
  },
  async downloadDocumentosAbertura () {
    await axios({
      method: 'GET',
      url: 'publico/arquivo/documentosAbertura',
      responseType: 'blob' // Importante em caso de download de files
    })
  },
  async downloadAutoDeclaracao () {
    await axios({
      method: 'GET',
      url: 'publico/arquivo/autoDeclaracao',
      responseType: 'blob' // Importante em caso de download de files
    })
  }
}

export default {
  namespaced: true,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/portal/publico/downloadPortal.js